import React from 'react';
import {
	AppBar,
	Box,
	Container,
	Dialog,
	Drawer,
	Grid,
	IconButton,
	useMediaQuery,
} from '@mui/material';
import Logo from './../../../components/Logo';
import { UserContext } from '../../../provider/user';
import PublicMenu from './components/PublicMenu';
import MemberMenu from './components/MemberMenu';
import VendorMenu from './components/VendorMenu';
import AdminMenu from './components/AdminMenu';
import AppGlobalSearch from '../../../components/content/AppGlobalSearch';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { DefaultTheme } from '@mui/styles';

export default function Header(props: any) {
	const isMobile = useMediaQuery((theme: DefaultTheme) => theme.breakpoints.down('md'));

	const [menuOpen, setMenuOpen] = React.useState(false);
	const [searchOpen, setSearchOpen] = React.useState(false);

	const { authorized, user } = React.useContext(UserContext);

	return (
		<AppBar
			id="app-header"
			sx={{
				backgroundColor: 'background.paper',
				boxShadow: 'none',
				borderBottom: 1,
				borderBottomColor: 'divider',
				paddingY: 1,
			}}
			position="sticky"
			{...props}
		>
			<Container>
				{isMobile ? (
					<>
						<Grid container justifyContent="space-between" alignItems="center">
							<Grid item>
								<IconButton
									aria-label="open navigation"
									sx={{
										padding: '7px',
									}}
									onClick={() => setMenuOpen(true)}
									aria-controls="app-navigation"
									aria-expanded={!menuOpen}
								>
									<MenuIcon
										sx={{
											fontSize: 28,
											color: 'text.primary',
										}}
									/>
								</IconButton>
							</Grid>
							<Grid item>
								<Logo width={150} />
							</Grid>
							<Grid item>
								<IconButton
									type="submit"
									aria-label="search"
									sx={{
										padding: '7px',
									}}
									onClick={() => setSearchOpen(true)}
								>
									<SearchIcon
										sx={{
											fontSize: 28,
											color: 'text.primary',
										}}
									/>
								</IconButton>
							</Grid>
						</Grid>
						<Drawer
							anchor="left"
							open={menuOpen}
							onClose={() => setMenuOpen(false)}
							id="app-navigation"
						>
							<Box
								sx={{
									position: 'relative',
									paddingTop: 6,
									paddingX: 2,
									paddingBottom: 2,
								}}
							>
								<Box>
									{authorized && user && 'member' === user.role && <MemberMenu />}
									{authorized && user && 'vendor' === user.role && <VendorMenu />}
									{authorized && user && 'admin' === user.role && <AdminMenu />}
									{!authorized && <PublicMenu />}
								</Box>
								<IconButton
									type="submit"
									aria-label="close navigation"
									sx={{
										padding: '7px',
										position: 'absolute',
										top: 10,
										right: 10,
									}}
									onClick={() => setMenuOpen(false)}
								>
									<CloseIcon
										sx={{
											fontSize: 28,
											color: 'text.primary',
										}}
										aria-controls="app-navigation"
										aria-expanded={menuOpen}
									/>
								</IconButton>
							</Box>
						</Drawer>
						<Dialog fullScreen open={searchOpen} onClose={() => setSearchOpen(false)}>
							<Box
								sx={{
									height: 1,
									padding: 4,
									backgroundColor: 'background.default',
								}}
							>
								<IconButton
									aria-label="close search panel"
									sx={{
										padding: '7px',
										position: 'absolute',
										top: 10,
										right: 10,
									}}
									onClick={() => setSearchOpen(false)}
								>
									<CloseIcon
										sx={{
											fontSize: 28,
											color: 'text.primary',
										}}
										aria-controls="app-search-panel"
										aria-expanded={searchOpen}
									/>
								</IconButton>
								<Box
									sx={{
										display: 'flex',
										alignItems: 'center',
										height: 1,

										marginLeft: { sm: 3 },
										width: { sm: 'auto' },
									}}
								>
									<AppGlobalSearch />
								</Box>
							</Box>
						</Dialog>
					</>
				) : (
					<Grid container alignItems="center" justifyContent="space-between">
						<Grid item>
							<Grid container alignItems="center">
								<Grid item>
									<Logo />
								</Grid>
								<Grid item>
									<Box
										sx={{
											display: 'flex',
											alignItems: 'center',
											height: 1,

											marginLeft: { sm: 3 },
											width: { sm: 'auto' },
										}}
									>
										<AppGlobalSearch />
									</Box>
								</Grid>
							</Grid>
						</Grid>
						<Grid item>
							<Grid container alignItems="center" justifyContent="flex-end">
								{authorized && user && 'member' === user.role && <MemberMenu />}
								{authorized && user && 'vendor' === user.role && <VendorMenu />}
								{authorized && user && 'admin' === user.role && <AdminMenu />}
								{!authorized && <PublicMenu />}
							</Grid>
						</Grid>
					</Grid>
				)}
			</Container>
		</AppBar>
	);
}
